const d_devtricker_console_log = true;

const devtricker_log_level = {
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
    FATAL: 'FATAL'
};

function devtricker_log(error, logLevel, details) {
    if (!window.location.href.startsWith("http://localhost") && !window.location.href.startsWith("https://localhost")) {
        return;
    }

    if (!logLevel) {
        throw new Error('logLevel is required');
    }

    let timestamp = new Date().toISOString();

    const message = error ? (error.message || 'No log message') : 'No error provided';
    const stackTrace = error ? (error.stack || 'No Stack') : 'No error object';

    const logEntry = {
        timestamp,
        message,
        details,
        logLevel,
        stackTrace,
        pageUrl: window.location.pathname
    };

    if (d_devtricker_console_log) {
        console.log(`Devtricker ${logLevel} LOG:`, logEntry);
    }
}

//https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid
function devtricker_uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}